import { FieldRenderProps } from 'react-final-form';
import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import RichTextEditor from './RichTextEditor';

type Props = FieldRenderProps<string, any>;

// react-final-form wrapper around the shared RichTextEditor (item 87 revamp): one
// clean editing surface, formatting toolbar + fullscreen, resize, skin-aware.
const MarkdownTextInput: React.FC<Props> = ({ input, label }: Props) => (
  <Box w="full">
    {label && <Text fontSize="sm" color="brand.700" mb={1}>{label}</Text>}
    <RichTextEditor value={input.value} onChange={input.onChange} />
  </Box>
);

export default MarkdownTextInput;
